export default __webpack_public_path__ + "static/media/ddsu5168_2p_blue_rs485_gw214.5f9133cf.png";